import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { inject } from 'vue';
import { Translator } from 'types/injects/translator.type';
import InvoicingDisplaySettingsLoader from 'vcomponents/settings/invoicing/InvoicingDisplaySettingsLoader.vue';
import { type DisplayPreferences } from 'api/settings/invoicing/invoicingDisplaySettingsService';

export interface FieldEntry {
    field: keyof DisplayPreferences;
    label: string;
    value: boolean;
    isForced: boolean;
}

interface Props {
    headerLabel: string;
    fields: FieldEntry[];
    loading: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'InvoicingDisplayFieldsTable',
  props: {
    headerLabel: {},
    fields: {},
    loading: { type: Boolean }
  },
  emits: ["change"],
  setup(__props: any, { emit: __emit }) {



const emit = __emit;

const $t = inject('$t') as Translator;

const displayedOnDocumentLabel = $t.__('settings.invoicingDisplay.table.displayedOnDocument');
const forcedFieldTooltip = $t.__('settings.invoicingDisplay.isForced.tooltip');

return (_ctx: any,_cache: any) => {
  const _component_CompassTableHeadCell = _resolveComponent("CompassTableHeadCell")!
  const _component_CompassTableHead = _resolveComponent("CompassTableHead")!
  const _component_CompassTableBodyCell = _resolveComponent("CompassTableBodyCell")!
  const _component_CompassCheckbox = _resolveComponent("CompassCheckbox")!
  const _component_CompassPill = _resolveComponent("CompassPill")!
  const _component_CompassTooltip = _resolveComponent("CompassTooltip")!
  const _component_CompassTableRow = _resolveComponent("CompassTableRow")!
  const _component_CompassTable = _resolveComponent("CompassTable")!

  return (__props.loading)
    ? (_openBlock(), _createBlock(InvoicingDisplaySettingsLoader, { key: 0 }))
    : (_openBlock(), _createBlock(_component_CompassTable, {
        key: 1,
        isCheckable: false,
        class: "invoicing-display-fields-table",
        size: _ctx.CompassEnums.TableSize.MEDIUM
      }, {
        default: _withCtx(() => [
          _createVNode(_component_CompassTableHead, null, {
            default: _withCtx(() => [
              _createVNode(_component_CompassTableHeadCell, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(__props.headerLabel), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              }),
              _createVNode(_component_CompassTableHeadCell, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(displayedOnDocumentLabel)), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              })
            ]),
            _: 1 /* STABLE */
          }),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.fields, (item) => {
            return (_openBlock(), _createBlock(_component_CompassTableRow, {
              key: item.field
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CompassTableBodyCell, { class: "typographies-paragraph-medium-regular" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.label), 1 /* TEXT */)
                  ]),
                  _: 2 /* DYNAMIC */
                }, 1024 /* DYNAMIC_SLOTS */),
                _createVNode(_component_CompassTableBodyCell, { class: "invoicing-display-fields-table__fixed-width-cell" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_CompassCheckbox, {
                      modelValue: item.field,
                      "onUpdate:modelValue": ($event: any) => ((item.field) = $event),
                      checked: item.value,
                      showLabel: false,
                      onChange: (newValue) => emit('change', newValue, item.field)
                    }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue", "checked", "onChange"]),
                    (item.isForced)
                      ? (_openBlock(), _createBlock(_component_CompassTooltip, {
                          key: 0,
                          content: _unref(forcedFieldTooltip),
                          arrow: false
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_CompassPill, {
                              label: _unref($t).__('settings.invoicingDisplay.isForced'),
                              icon: "eyeshow-fill",
                              variant: _ctx.CompassEnums.PillVariant.PASTEL,
                              color: _ctx.CompassEnums.PillColor.ORANGE,
                              size: _ctx.CompassEnums.PillSize.EXTRA_SMALL
                            }, null, 8 /* PROPS */, ["label", "variant", "color", "size"])
                          ]),
                          _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["content"]))
                      : _createCommentVNode("v-if", true)
                  ]),
                  _: 2 /* DYNAMIC */
                }, 1024 /* DYNAMIC_SLOTS */)
              ]),
              _: 2 /* DYNAMIC */
            }, 1024 /* DYNAMIC_SLOTS */))
          }), 128 /* KEYED_FRAGMENT */))
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["size"]))
}
}

})